var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLayoutNoTabs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 50,
    viewBox: "0 0 74 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.37037 0C0.613536 0 0 0.89543 0 2V12C0 13.1046 0.613535 14 1.37037 14H45.9074C46.6642 14 47.2778 13.1046 47.2778 12V2C47.2778 0.895431 46.6642 0 45.9074 0H1.37037ZM1.37037 18C0.613536 18 0 18.8954 0 20V26C0 27.1046 0.613536 28 1.37037 28H20.5556C21.3124 28 21.9259 27.1046 21.9259 26V20C21.9259 18.8954 21.3124 18 20.5556 18H1.37037ZM25.3519 20C25.3519 18.8954 25.9654 18 26.7222 18H45.9074C46.6642 18 47.2778 18.8954 47.2778 20V26C47.2778 27.1046 46.6642 28 45.9074 28H26.7222C25.9654 28 25.3519 27.1046 25.3519 26V20ZM1.37037 32C0.613536 32 0 32.8954 0 34V48C0 49.1046 0.613535 50 1.37037 50H45.9074C46.6642 50 47.2778 49.1046 47.2778 48V34C47.2778 32.8954 46.6642 32 45.9074 32H1.37037ZM50.0185 2C50.0185 0.89543 50.6321 0 51.3889 0H72.6296C73.3865 0 74 0.895431 74 2V16C74 17.1046 73.3865 18 72.6296 18H51.3889C50.6321 18 50.0185 17.1046 50.0185 16V2ZM51.3889 22C50.6321 22 50.0185 22.8954 50.0185 24V32C50.0185 33.1046 50.6321 34 51.3889 34H72.6296C73.3865 34 74 33.1046 74 32V24C74 22.8954 73.3865 22 72.6296 22H51.3889Z",
    fill: "#3C3A42"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLayoutNoTabs);
export default __webpack_public_path__ + "static/media/icon-layout-no-tabs.03fc2b338c07833f57659eb2feecf022.svg";
export { ForwardRef as ReactComponent };